<template>
   <div class="BasicNature row">
        <div class="col-12">
            <multiselection id="BusinessNatureList" 
                    v-model="temp_Value.BusinessNatureList" 
                    label="name" track-by="code" :MaxLength="3"
                    :options="temp_BusinessNatureOptions" 
                    :multiple="true" :taggable="true"
                    :title="$t('lbl_EMPBE_CompanyInfo_Basic_BusinessNature_PlaceOther')"
                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_BusinessNature') + $t('lbl_IsRequire')" >
              </multiselection>
        </div>
             
        <div class="BottomCard col-12" v-if="ShowBottonDilog">
            <div class="allow"><img :src="cdnURL+'Polygon.svg'"></div>
            <div class="cardContent">
                <div class="Manufacturer" v-if="IsHasManufacturer" >
                    <div class="cardContent_title"> 
                        {{$t('lbl_EMPBE_CompanyInfo_Basic_Manufacturer')}}
                    </div>
                    <div class="cardContent_p"> 
                        {{$t('lbl_EMPBE_CompanyInfo_Basic_Manufacturer_P')}}
                    </div>
                    <div class="Manufacturer_Input">
                        <div>
                            <switchIput  
                              :left="$t('lbl_EMPBE_Yes')"
                            :right="$t('lbl_EMPBE_No')"
                            class="mt-2" ControlId="IsAgents" v-model="temp_Value.IsAgents">
                            </switchIput>
                        </div>
                        <div v-if="temp_Value.IsAgents">
                            <div class="row col-12">
                                <multiselection 
                                    id="CompanyList" 
                                    v-model="temp_Value.CompanyList" 
                                    label="name" track-by="code"
                                    :options="temp_OptionCountrys" 
                                    :multiple="true" :taggable="true"
                                    :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_Manufacturer_Country_PlaceOther')+ $t('lbl_IsRequire')" 
                                    :title="$t('lbl_EMPBE_CompanyInfo_Basic_Manufacturer_Country_PlaceOther')">
                                </multiselection>
                            </div>
                            <div>
                               {{$t('lbl_EMPBE_CompanyInfo_Basic_Manufacturer_Country_P')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="other" v-if="IsHasOther">
                    <div class="cardContent_title cardContent_title_Other"> 
                        {{$t('lbl_EMPBE_CompanyInfo_Basic_Other')}}
                    </div>
                    <div>
                        <textbox 
                            ControlId="Others" 
                            :title="$t('lbl_EMPBE_CompanyInfo_Basic_Other_PlaceOther') "
                            max="40"
                            v-model="temp_Value.Others" 
                            :mandatory="$t('lbl_EMPBE_CompanyInfo_Basic_Other_PlaceOther') + $t('lbl_IsRequire')">
                        </textbox>
                    </div>
                </div>
                
            </div>
        </div>
   </div> 
</template>
<script>
export default {
    props: ["value","countryOptions","BusinessNatureOptions"],
    data(){
        return{
            temp_Value:this.value,
            temp_BusinessNatureOptions: this.BusinessNatureOptions,
            temp_OptionCountrys:this.countryOptions,
            cdnURL:"https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
            ShowBottonDilog:false,
            OthersVal:"",
        }
    },
    watch:{
        value() {
            this.temp_value = this.value;
        },
        temp_Value: {
            handler() 
            {
                this.IsShowBottonDilog();
                this.$emit("input",this.temp_Value);

            },deep:true
        },
        countryOptions: {
            handler() 
            {
                this.temp_OptionCountrys=this.countryOptions;

            },deep:true
        },
        BusinessNatureOptions: {
            handler() 
            {
                this.temp_BusinessNatureOptions=this.BusinessNatureOptions;
                this.IsShowBottonDilog();

            },deep:true
        },
    },
    computed: {
        IsHasOther(){
            var res = this.temp_BusinessNatureOptions.filter(item=>this.temp_Value.BusinessNatureList.includes(item.id))
            return res.find(item=>item.id=="99")
        },
        IsHasManufacturer(){
            var res = this.temp_BusinessNatureOptions.filter(item=>this.temp_Value.BusinessNatureList.includes(item.id))
            return res.find(item=>item.id=="1")
        }
    },
    methods: {
        IsShowBottonDilog()
        {
                this.ShowBottonDilog=false;
                if(this.IsHasOther || this.IsHasManufacturer)
                {
                    this.ShowBottonDilog=true;
                }
        }
    }

}
</script>
<style lang="scss" scoped>
.BasicNature
{
    .form-group
    {
        margin-bottom: 0px !important;
    }
    .BottomCard
    {
        margin-bottom: 25px;
        position: relative;
    }
    .allow
    {
        padding-left: 30px;
        margin-bottom: -1px;
    }
    .cardContent
    {
        padding: 16px;
        border-radius: 16px;
        background: #F7F7F7
    }
    .cardContent_title
    {
        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; 
        letter-spacing: 0.15px;
    }
    .cardContent_title_Other
    {
        margin-bottom: 8px;
    }
    .cardContent_p
    {
        color: var(--on-surface-60, rgba(0, 0, 0, 0.60));
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 21px */
        letter-spacing: 0.15px;
    }
    .Manufacturer_Input
    {
        display: flex;
        align-items: center;
        gap: 16px;
        align-self: stretch;
        margin-top: 8px;
    }
  

}
</style>
<style scoped>
  ::v-deep .CPSForm-label
    {
        background: linear-gradient(to bottom, #F7F7F7, #fff) !important;
    }
</style>